import { useEffect, useState, useMemo } from 'react';
import {
  collection,
  query,
  orderBy,
  onSnapshot,
  QueryDocumentSnapshot,
} from 'firebase/firestore';
import { db } from '../../services/firebase';
import { PortalHeader } from '../Layout/PortalHeader';
import { SupportTicketFilters, TicketFilter } from './SupportTicketFilters';
import { SupportTicketRow } from './SupportTicketRow';

export function SupportTickets() {
  const [tickets, setTickets] = useState<any[]>([]);
  const [filter, setFilter] = useState<TicketFilter>('open');
  const [refreshKey, setRefreshKey] = useState(0);

  useEffect(() => {
    const base = collection(db, 'supportTickets');
    const q = query(base, orderBy('createdAt', 'desc'));
    const unsub = onSnapshot(q, snap => {
      setTickets(
        snap.docs.map((d: QueryDocumentSnapshot) => ({
          id: d.id,
          ...d.data(),
        }))
      );
    });
    return unsub;
  }, [refreshKey]);

  const counts = useMemo(() => {
    const base: Record<TicketFilter, number> = {
      open: 0,
      acknowledged: 0,
      investigating: 0,
      resolved: 0,
      all: tickets.length,
    };
    for (const t of tickets) {
      if (t.status in base) base[t.status as TicketFilter]++;
    }
    return base;
  }, [tickets]);

  const visible = tickets.filter(t => filter === 'all' || t.status === filter);

  return (
    <div>
      <PortalHeader showCredits={false} />
      <div className="container" style={{ maxWidth: 1100, padding: '20px 16px' }}>
        <h1>Support Tickets</h1>
        <SupportTicketFilters current={filter} counts={counts} onChange={setFilter} />
        {visible.length === 0 ? (
          <p style={{ opacity: 0.6 }}>No tickets in this view.</p>
        ) : (
          visible.map(t => (
            <SupportTicketRow
              key={t.id}
              ticket={t}
              onChange={() => setRefreshKey(k => k + 1)}
            />
          ))
        )}
      </div>
    </div>
  );
}
